import {
    AnimationMixer,
    Object3D, 
    Vector3,
    LoopOnce,
} from "three"
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader"
import { MeshoptDecoder } from "three/examples/jsm/libs/meshopt_decoder.module"

import {
    Body,
    Cylinder,
 } from 'cannon-es'

import { gsap } from "gsap"

import { QuestionsController } from "./questionsController"

import { crossfadeAction, degToRad } from "../components/alpha"
import { defPath } from '../config/defPath'


// ------------------------------------------------------------


export class NPC {

    #_loader = new GLTFLoader()

    #_positions = { }
    #_mixers = { }

    #_scene

    #_3dBase
    #_mixer
    #_baseAction

    #_activeNPC

    //

    constructor(scene) {
        this.#_scene = scene

        //
        const name = 'base'
        const loadControl = window.loadControl
        this.#_3dBase = new Promise( resolve => {
            this.#_loader
            .load( `${defPath}/assets/glb/${name}.glb`,
                (gltf) => {
                    const scene = gltf.scene

                    const sf = 7
                    scene.scale.set(sf,sf,sf)
                    scene.rotateY(Math.PI)

                    const mixer = new AnimationMixer(scene)
                    this.#_mixers[name] = mixer
                    
                    // this.#_mixer.timeScale = 0.25
                    const [clip] = gltf.animations
                    this.#_baseAction = mixer.clipAction(clip)

                    resolve(scene)
                },
                (xhr) => {
                    loadControl.elements['glb_' + name] = { loaded: xhr.loaded, total: xhr.total }
                    if (loadControl.allowLogSize && xhr.loaded === xhr.total) console.log(`GLB "${name}" - ${(xhr.total / 1024 / 1024).toFixed(2)}Mb`)
                },
                (error) => {
                    console.warn(`[A] ${name}: Error loading`)
                    // console.warn( error )
                }
            )
        })
    }

    //

    get active() {
        return this.#_activeNPC
    }

    //

    loadNPCs(namesArray) {
        const loadControl = window.loadControl

        let tempPos = [
            {x: -35, z: 50, w: degToRad(45)},

            {x: 45, z: 60, w: degToRad(270)},
            {x: 35, z: 60, w: degToRad(90)},

            {x: -55, z: 70, w: degToRad(180)},
            {x: -15, z: -100, w: degToRad(0)},
            {x: 45, z: 100, w: degToRad(180)},
            {x: 60, z: -105, w: degToRad(320)},
            {x: 105, z: -20, w: degToRad(270)},
            {x: 100, z: -30, w: degToRad(320)},
            {x: -70, z: -70, w: degToRad(45)},
        ] //.sort( () => {return Math.random() - 0.5} ) // Desorganizar

        for( let i = 0; i < namesArray.length; i++) {
            //
            const name = namesArray[i]

            //
            this.#_positions[name] = tempPos[i]

            //
            this.#_loader
                .setMeshoptDecoder(MeshoptDecoder)
                .load( `${defPath}/assets/glb/npc/${name}.glb`,
                    (gltf) => {
                        this._handleNPC(gltf, name)
                    },
                    (xhr) => {
                        loadControl.elements['glb_npc_' + name] = { loaded: xhr.loaded, total: xhr.total }
                        if (loadControl.allowLogSize && xhr.loaded === xhr.total) console.log(`GLB NPC - "${name}" - ${(xhr.total / 1024 / 1024).toFixed(2)}Mb`)
                    },
                    (error) => {
                        console.warn(`glb_npc_${name}: Error loading`)
                        // console.warn( error )
                    }
                )
        }
    }

    async _handleNPC(gltf, NPC_name) {

        const pos = {x: this.#_positions[NPC_name].x, y: 0, z: this.#_positions[NPC_name].z}
        const rotY = this.#_positions[NPC_name].w

    // Three -----------------

        const model = gltf.scene

        model.position.copy( pos )
        model.rotateY(rotY)

        model.castShadow = true
        model.traverse( obj => obj.castShadow = true )
        
        window.scene.add(model)

        const mixer = new AnimationMixer(model)
        this.#_mixers[NPC_name] = mixer

        const clips = gltf.animations
        const actions = {}
        clips.forEach( clip => {           
            const action = mixer.clipAction( clip )
            action.weight = 0
            actions[clip.name] = action
        })
        actions['Idle'].weight = 1
        actions['Idle'].play()


    // Cannon -----------------

        const bodySize = clips.length > 1 ? 7 : 4

        const body = new Body({
            shape: new Cylinder(bodySize + 1,bodySize,4,12),    //new Box( new Vec3(4,0.5,4) ),
        })
        body.position.set(pos.x, 2.5, pos.z) 
        body.quaternion.copy(model.quaternion)
        window.world.addBody(body)



    // Interaction -----------------
    
        if(clips.length > 1) {
        
            const questionsAvaible = await new QuestionsController().questionsAvailable()
            if (!questionsAvaible) return

            const base = await this.#_3dBase
            this.#_baseAction.play()
            model.add(base)

            const _collided = () => {

                if (active.collided) return
                active.collided = true

                this.#_activeNPC = active
                
                //
                //* Determinar que tipo de interaccion es: Preguntas, informacion, etc
                
                new QuestionsController().open()
                
                window.soundController.play('questions', false, 1, 0.5)

                // Camera enphasis
                const a = pos
                const b = window.avatar.active.model.position
                window.cameraController.questionCloseUp(a, b)

                // Three
                model.lookAt( window.avatar.active.model.position )
                window.avatar.active.model.lookAt( model.position )

                crossfadeAction( actions['Idle'], actions['Hablar'], 1)

            }
            const active = {
                collided: false,
                name: NPC_name,
                base,
                body,
                actions,
                callback: _collided,
            }

            body.addEventListener('collide', _collided)
        }
    }

    restore() {
        // If pop is closed
        const active = this.#_activeNPC

        crossfadeAction( active.actions['Hablar'], active.actions['Idle'], 1)

        setTimeout( () => {
            active.collided = false
            this.#_activeNPC = undefined
        }, 5000)

    }

    complete() {
        // If was answered the question
        const active = this.#_activeNPC

        //---- this.restore() is triggered before this.complete()

        active.base.removeFromParent()
        active.body.removeEventListener('collide', active.callback)

    }

    initNPC(name) {
        this.#_loader
            .setMeshoptDecoder(MeshoptDecoder)
            .load( `${defPath}/assets/glb/npc/${name}.glb`,
                (gltf) => {

                    const model = gltf.scene
                    // model.scale.set(1.8,1.8,1.8)
                    model.rotateY(Math.PI)
                    model.castShadow = true
                    model.traverse( obj => obj.castShadow = true )
                    
                    // window.scene.add(model)
                    this.#_scene ? this.#_scene.add(model) : window.scene.add(model)

                    const mixer = new AnimationMixer(model)
                    this.#_mixers[name] = mixer

                    const clips = gltf.animations
                    const actions = {}
                    clips.forEach( clip => {
                        const action = mixer.clipAction( clip )
                        action.name = clip.name
                        action.loop = LoopOnce
                        action.clampWhenFinished = true
                        actions[clip.name] = action
                    })
                    actions[ clips[1].name ].play()

                    let counter = 1 // Repetitions counter
                    mixer.addEventListener('finished', (e) => {
                        ++counter

                        const current = actions[e.action.name]
                        const next = actions[ clips[counter % clips.length].name ]
                            // console.log(name, counter % n, clips[counter % n].name)
                        crossfadeAction(current, next, 0.75)
                    })

                },
                (xhr) => {
                    loadControl.elements['glb_npc_' + name] = { loaded: xhr.loaded, total: xhr.total }
                    if (loadControl.allowLogSize && xhr.loaded === xhr.total) console.log(`[${sigla}] name "${name}" - ${(xhr.total / 1024 / 1024).toFixed(2)}Mb`)
                },
                (error) => {
                    console.warn(`glb_npc_${name}: Error loading`)
                    // console.warn( error )
                }
            )
    }

    update(delta) {
        Object.values(this.#_mixers).forEach( m => m.update(delta) )
    }
}